import { render, staticRenderFns } from "./ProjectDataTable.vue?vue&type=template&id=58051884"
import script from "./ProjectDataTable.vue?vue&type=script&lang=js"
export * from "./ProjectDataTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports